import { JsonObject, JsonProperty } from 'json2typescript';
import { Product } from './product-model';

@JsonObject('ProductWithMetadata')
export class ProductWithMetadata extends Product {
  @JsonProperty('barcode', String, true) barcode: string = undefined;
  @JsonProperty('title', String, true) title: string = undefined;
  @JsonProperty('brand', String, true) brand: string = undefined;
}
